import React from 'react';

import Label from '../../Labels/Label';
import ChatMessages from './ChatMessages';
import ChatNewMessage from './ChatNewMessage';

import "../Chats.css";

const ChatPublic = () => {
    return (
        <div className='row'>
            <Label text="CHAT PÚBLICO" />

            <div className="col-md-12 mb-2">
                <ChatMessages />
            </div>

            <div className="col-md-12 mb-2">
                <ChatNewMessage />
            </div>
        </div>
    );
};

export default ChatPublic;
